import { Grid } from "@pankod/refine-mui";

import AutoGeneratedInputCmp from "components/auto-generated-input/AutoGeneratedInputCmp";

export default function CompFields({
  register,
  control,
  errors,
  defaultLanguageRecord,
  getValues,
  setError,
  setValue,
  watch,
  disabled,
}) {
  const fields = [
    {
      label: "Nome",
      name: "firstName",
      required: true,
      type: "text",
      disabled: true,
    },
    {
      label: "Cognome",
      name: "lastName",
      required: true,
      type: "text",
      disabled: true,
    },
    {
      label: "Email",
      name: "email",
      required: true,
      type: "text",
      disabled: true,
    },
    {
      label: "Nazionalità",
      name: "nationality",
      required: false,
      type: "text",
    },
    {
      label: "Telefono",
      name: "phoneNumber",
      required: false,
      type: "text",
    },
    {
      label: "Codice fiscale",
      name: "fiscalCode",
      required: false,
      type: "text",
    },
    {
      label: "Partita IVA",
      name: "partitaIVA",
      required: false,
      type: "text",
    },
    {
      label: "Cliente attivo",
      name: "active",
      required: false,
      type: "switch",
    },
    { type: "divider" },
    {
      type: "title",
      variant: "h6",
      label: "Dati di fatturazione",
    },
    {
      label: "Indirizzo",
      name: "address",
      required: false,
      type: "text",
    },
    {
      label: "Città",
      name: "city",
      required: false,
      type: "text",
    },
    {
      label: "CAP",
      name: "zip",
      required: false,
      type: "text",
    },
    {
      label: "Provincia",
      name: "province",
      required: false,
      type: "text",
    },
    {
      label: "Nazione",
      name: "country",
      required: false,
      type: "text",
    },
  ];

  return (
    <Grid container spacing={2}>
      {fields.map((field, index) => {
        return (
          <AutoGeneratedInputCmp
            key={index}
            disabled={disabled}
            {...field}
            register={register}
            control={control}
            errors={errors}
            setError={setError}
            fieldVariants="outlined"
            defaultValue={watch(field.name)}
            defaultLanguageRecord={defaultLanguageRecord}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
        );
      })}
    </Grid>
  );
}
